import { render, staticRenderFns } from "./IdentityProvider.vue?vue&type=template&id=14a4cfaa&scoped=true&lang=html&"
import script from "./IdentityProvider.vue?vue&type=script&lang=js&"
export * from "./IdentityProvider.vue?vue&type=script&lang=js&"
import style0 from "./IdentityProvider.vue?vue&type=style&index=0&id=14a4cfaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a4cfaa",
  null
  
)

export default component.exports